import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { NotificationStore } from '../../stores';

import { Modal } from 'antd';
import { NotificationCard } from './NotificationCard';

interface NotificationModalProps {
    notificationStore?: NotificationStore;
}

const ContainerModal = styled(Modal)`
    .ant-modal-body {
        padding: unset;
    }
`;

const EditContainerModal = styled(ContainerModal)`
    min-width: 750px;
`;

@inject('notificationStore')
@observer
export class NotificationModal extends React.Component<NotificationModalProps, {}> {
    handleCancel = () => {
        const { notificationStore } = this.props;
        const { mode } = notificationStore!;
        if (mode === 'edit') {
            notificationStore!.changeMode('view');
        } else {
            notificationStore!.unselectNotification();
        }
    };

    render() {
        const { notificationStore } = this.props;
        const { openModal, selectedNotification, mode } = notificationStore!;
        const Container = mode === 'view' ? ContainerModal : EditContainerModal;

        return (
            <Container
                centered={true}
                visible={openModal}
                onCancel={this.handleCancel}
                footer={null}
                closable={mode === 'view'}
                maskClosable={false}
            >
                <NotificationCard
                    notification={selectedNotification!}
                    kind="full"
                    editable={mode === 'edit'}
                />
            </Container>
        );
    }
}
